var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"app-logo",attrs:{"href":"/"}},[_c('img',{staticClass:"app-logo-img",attrs:{"id":"logo","src":require("@/assets/img/global/logo.png"),"alt":"上船吧logo"}})])
}]

export { render, staticRenderFns }